import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import { HeadeSearch } from "@components/head-search";
import { PageFooter } from "@components/page-footer";
import Mail from "@components/mail/mail.vue";
import { MainTabs } from "@components/main-tabs";
import { PageTop } from "@components/page-top";
import redPacketNotice from '@/components/red-packet-notice';
import { Storage } from "@services/storage";
import { Account, AccountStorage } from "@services/account";
var storage = new Storage();
var account = new Account();
var accountStorage = new AccountStorage();
var ModalForm = {
  template: "\n            <div class=\"modal-card\" style=\"width: 300px;\">\n                <header class=\"modal-card-head\" style=\"text-align: left;\">\n                    <p class=\"modal-card-title\">\u8D26\u5355\u63D0\u9192</p>\n                    <button\n                        type=\"button\"\n                        class=\"delete\"\n                        @click=\"$emit('close')\" />\n                </header>\n                <div class=\"modal-card-body\" style=\"text-align: center;\">\n                  <p>\u60A8\u6709\u672A\u7F34\u8D26\u5355\uFF0C\u8BF7\u53CA\u65F6\u4ED8\u6B3E\uFF01</p>\n                </div>\n                <footer class=\"modal-card-foot\">\n                    <b-button\n                        size=\"is-small\"\n                        label=\"\u53BB\u652F\u4ED8\"\n                        type=\"is-primary\"\n                        style=\"margin: 0 auto;\"\n                        @click=\"$emit('close');$emit('goToBillHandler');\" />\n                </footer>\n            </div>\n        "
};
export default {
  data: function data() {
    return {
      carousels: [],
      //主广告图
      subAdvertising: [],
      isLogin: false,
      tabActive: 0,
      isExternal: false,
      couponDialog: false,
      couponList: [],
      mailDialog: false
    };
  },
  created: function created() {
    var vm = this;
    var accountStorage = new AccountStorage();
    window.addEventListener('message', function (event) {
      // 传送的数据在event.data里面
      var userInfo = event.data;
      if (userInfo.account && userInfo.account) {
        if (userInfo.userId) {
          accountStorage.setCacheUserInfo(userInfo);
          vm.$store.commit('setIframeLogin', userInfo.fromIframe ? userInfo.fromIframe : false);
          vm.isLogin = true;
        }
      }
    });
    vm.isLogin = account.isLogined();
    if (this.isLogin) this.getCoupon();
    var isShowMail = localStorage.getItem('isShowMail');
    if (!isShowMail) this.mailDialog = true;
  },
  components: {
    HeadeSearch: HeadeSearch,
    PageFooter: PageFooter,
    MainTabs: MainTabs,
    PageTop: PageTop,
    Mail: Mail,
    redPacketNotice: redPacketNotice
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var userInfo;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.getBannerList();
          case 2:
            _context.next = 4;
            return _this.getAdvertList();
          case 4:
            userInfo = accountStorage.getCacheUserInfo();
            if (userInfo) {
              _this.isExternal = userInfo.type == 1 ? true : false;
            }
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    //关闭致谢信
    closeMail: function closeMail(flag) {
      this.mailDialog = false;
      localStorage.setItem('isShowMail', 1);
    },
    //获取列表
    getCoupon: function getCoupon() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.$getHttpClient().get("/pjyy-deepexi-coupon-center/api/v1/queryCouponByCustomerCode");
            case 2:
              res = _context2.sent;
              if (res.data.code == 200) {
                _this2.couponList = res.data.data || [];
                if (_this2.couponList.length) _this2.couponDialog = true;
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    //立即使用
    nowUse: function nowUse() {
      this.$router.push({
        path: "/channel/channel-detail/" + "0/0"
      });
    },
    goToBillHandler: function goToBillHandler() {
      var userInfo = accountStorage.getCacheUserInfo();
      var reminder = storage.get("reminder") || {};
      reminder[userInfo.loginCompanyId] = 1;
      storage.set("reminder", reminder);
      this.$router.push({
        path: "/user-center/bill/list/0"
      });
    },
    checkBillStatus: function checkBillStatus() {
      if (this.isLogin) {
        var userInfo = accountStorage.getCacheUserInfo();
        if (!userInfo.normalStatus) {
          var reminder = storage.get("reminder") || {};
          if (!reminder[userInfo.loginCompanyId]) {
            this.$buefy.modal.open({
              parent: this,
              component: ModalForm,
              hasModalCard: true,
              events: {
                goToBillHandler: this.goToBillHandler
              }
            });
          }
        }
      }
    },
    update: function update() {
      this.isLogin = account.isLogined();
      this.getBannerList();
      this.getAdvertList();
      var userInfo = accountStorage.getCacheUserInfo();
      if (userInfo) {
        this.isExternal = userInfo.type == 1 ? true : false;
      }
    },
    goToSubmit: function goToSubmit() {
      var _this3 = this;
      var url = "/pjyy-deepexi-user-center/api/v1/customer/myAuditStatus";
      this.$getHttpClient().get(url).then(function (res) {
        if (res.data.code == "200" && res.data.data.auditStatus == "NOTSUB") {
          _this3.$router.push({
            path: "/user-center/submit-qualification"
          });
        } else {
          _this3.$router.push({
            path: "/user-center/audit-detail"
          });
        }
      });
    },
    toProductDetail: function toProductDetail(type, pcUrl, pcId, actiid) {
      if ((pcUrl.indexOf("/channel-new-detail/2") > -1 || pcUrl.indexOf("/channel/channel-detail/3") > -1) && this.isExternal) {
        this.$buefy.toast.open({
          message: "您尚未成为正式会员，无法进入该页面",
          type: "is-danger"
        });
        return;
      }
      type = Number(type);
      // 0.商品详情  1.外链  2.没有
      if (type == 2) {
        return;
      } else if (type == 0) {
        this.$router.push({
          name: "details",
          params: {
            id: pcId
          }
        });
      } else {
        if (actiid) {
          window.location.href = pcUrl + "?activityid=" + actiid;
        } else {
          window.location.href = pcUrl;
        }
      }
    },
    onClickTab: function onClickTab(event) {
      event.children.map(function (item) {
        item.pagenum = 0;
        item.datalist = [];
      });
      if (this.isExternal) {
        this.$buefy.toast.open({
          message: "您尚未成为正式会员，无法进入该页面",
          type: "is-danger"
        });
        this.$router.push({
          path: "/"
        });
      } else {
        this.$router.push({
          path: "/channel/channel-detail/" + event.index + "/0"
        });
      }
    },
    // 主广告图
    getBannerList: function getBannerList() {
      var _this4 = this;
      return this.$getHttpClient().get("/pjyy-deepexi-aggregation/api/v1/advertising/findByCondition").then(function (res) {
        var result = res.data ? res.data.data : [];
        if (result) {
          _this4.carousels = res.data ? res.data.data : [];
        }
        return res;
      });
    },
    // 副广告图
    getAdvertList: function getAdvertList() {
      var _this5 = this;
      return this.$getHttpClient().get("/pjyy-deepexi-aggregation/api/v1/advertisingAssistant/findByCondition").then(function (res) {
        _this5.subAdvertising = res.data ? res.data.data : [];
        return res;
      });
    }
  }
};